<template>
  <div></div>
</template>

<script>
export default {
  name: "Share",
  data() {
    return {
      shareC: {
        title: "流派互转上线，点击查看你的本命职业！",
        desc: "《逆水寒》流派转换，3月21日全服上线！诸法自在，唯心不易。"
      },
      arStr: [
        "q",
        "w",
        "e",
        "r",
        "t",
        "y",
        "u",
        "i",
        "o",
        "p",
        "a",
        "s",
        "d",
        "f",
        "g",
        "h",
        "j",
        "k",
        "l",
        "z",
        "x",
        "c",
        "v",
        "b",
        "n",
        "m"
      ],
      urlStr: "",
      // role: ["碎梦", "血河", "神相", "铁衣", "九灵", "素问", "龙吟"],
      shareIcon: require("@/assets/img/share.jpg"), //分享icon
      shareIdiom: [
        "轻功了得",
        "一身是胆",
        "气质最仙",
        "最能抗压",
        "小弟最多",
        "人美心善",
        "套路最多"
      ]
    };
  },
  computed: {
    resVideo() {
      return this.$store.state.resVideo;
    },
    dirname() {
      return this.$store.state.__dirname;
    },
    url() {
      return this.dirname + this.urlStr + "/";
    },
    // 最终结果
    score() {
      return this.$store.state.score;
    },
    // 结果中最大值的下标
    max() {
      let maxNum = Math.max.apply(null, this.score);
      return this.score.indexOf(maxNum);
    }
  },
  watch: {
    resVideo() {
      this.updateShare();
    }
  },
  mounted() {
    this.randomUrl();
    this.share();
  },
  methods: {
    // 半截分享内容
    share() {
      let { title, desc } = this.shareC;
      let url = this.url;
      let imgurl = this.shareIcon;
      nie.define("sharetest", function() {
        var mbshare = nie.require("nie.util.mobiShare2");
        MobileShare.init({
          title: title,
          desc: desc,
          url: url,
          imgurl: imgurl,

          shareCallback: function(res) {
            //微信易信分享回调res=｛type:0,res:[微信返回的提示]｝res.type：0表示取消，-1：分享失败，1：分享到朋友圈，2：分享给好友，3：QQ，4：微博。易信只返回1或2两种情况。
            // alert(JSON.stringify(res));
          },
          wxSdkCallback: function() {
            //微信sdk加载完成后回调，可在此回调中调用微信JS-SDK的其他API,如上传图片等。
          }
        });
      });
    },
    // 最终海报分享内容
    // 0碎梦  1血河  2神相  3铁衣  4九灵  5素问  6龙吟
    updateShare() {
      let url = this.url;
      // let title = `我和${this.role[this.max]}的匹配度高达${
      //   this.score[this.max]
      // }%，转职后成为：${this.idiom}`;
      let title = `倒退1000年，我会是“${this.shareIdiom[this.max]}”的侠士`;
      let imgurl = this.shareIcon;

      MobileShare.updateShare({
        title: title,
        desc: "《逆水寒》流派转换，3月21日全服上线！诸法自在，唯心不易。",
        url: url, // 分享地址
        imgurl: imgurl // 分享icon 300X300
      });
    },
    // 随机地址
    randomUrl() {
      // 0-25
      // Math.ceil(Math.random() * 26) - 1
      for (let i = 0; i < 3; i++) {
        // 0-25
        this.urlStr += this.arStr[Math.ceil(Math.random() * 26) - 1];
      }
    }
  }
};
</script>

